import { render, staticRenderFns } from "./OverviewOrderView.vue?vue&type=template&id=1d4821da&scoped=true&"
import script from "./OverviewOrderView.vue?vue&type=script&lang=js&"
export * from "./OverviewOrderView.vue?vue&type=script&lang=js&"
import style0 from "./OverviewOrderView.vue?vue&type=style&index=0&lang=css&"
import style1 from "./OverviewOrderView.vue?vue&type=style&index=1&id=1d4821da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4821da",
  null
  
)

export default component.exports